var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3002 1.20973C12.9102 0.819727 12.2802 0.819727 11.8902 1.20973L7.00022 6.08973L2.11022 1.19973C1.72022 0.809727 1.09021 0.809727 0.700215 1.19973C0.310215 1.58973 0.310215 2.21973 0.700215 2.60973L5.59022 7.49973L0.700215 12.3897C0.310215 12.7797 0.310215 13.4097 0.700215 13.7997C1.09021 14.1897 1.72022 14.1897 2.11022 13.7997L7.00022 8.90973L11.8902 13.7997C12.2802 14.1897 12.9102 14.1897 13.3002 13.7997C13.6902 13.4097 13.6902 12.7797 13.3002 12.3897L8.41021 7.49973L13.3002 2.60973C13.6802 2.22973 13.6802 1.58973 13.3002 1.20973Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.915dbba1372a4acda4055da7121147a1.svg";
export { ForwardRef as ReactComponent };